//Library imports
import { Fragment, useEffect, useState } from 'react';
import { useAsync } from 'react-async';
import { useHistory, useLocation } from 'react-router-dom';

//Services
import { getDisciplines } from '../../api/services/disciplineService';
import { getDistricts } from '../../api/services/districtService';

//Models and data types
import { selectOption } from '../../types/selectOption';

//Components
import Layout from '../../components/layout';
import Select from 'react-select';
import { graySelectStyles } from '../../common/selectStyles';
import { getTherapistNamesAndIds } from '../../api/services/therapistService';
import Therapists from '../../api/models/therapists';
import { Notification } from '../../components/notifications';
import { Pagination } from '../../components/pagination';
import FetchInput from '../../components/FetchInput';
import { getDivisions } from '../../api/services/divisionService';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getManualDuplicates, getPotentialDuplicates, mergeStudents } from '../../api/services/studentService';
import StudentMatch from '../../api/models/studentMatch';
import moment from 'moment';
import Modal from '../../components/modal';
import { therapistPageSizeOptions } from '../../common/constants';
import StudentCustomMergRequest from '../../api/requests/studentCustomMergRequest';
import StudentMerge from '../../api/models/studentMerge';
import StudentMergeModel from '../../components/modal/studentMergeModel';

//Get our view state
type ViewState = {
    message?: string;
};

type PageSizeProps = {
    options: number[];
    outerDivClasses?: string;
    changeHandler: Function;
    currentPageSize: number;
}

/**
 * Methods to fetch search criteria with which to populate
 */
const fetchDisciplines = async () => getDisciplines();
const fetchDistricts = async () => getDistricts();
const fetchDivisions = async () => getDivisions();
const fetchTherapists = async () => await getTherapistNamesAndIds();

//const doSearch = async (request: TherapistSearchRequest) => await searchTherapists(request);
const PageSizeSelector = ({ options, outerDivClasses, changeHandler, currentPageSize }: PageSizeProps) => {
    const selectOptions = options.map((item) => ({ value: item, label: String(item) }));
    return (
        <div className={outerDivClasses}>
            <p className='text-sm font-bold'>Records Per Page</p>
            <Select
                className='w-20 mt-2'
                styles={{
                    ...graySelectStyles,
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                }}
                menuPortalTarget={document.body}
                isSearchable={false}
                options={selectOptions}
                value={selectOptions.find((o) => o.value === currentPageSize) || null}
                onChange={(e: any) => changeHandler(e?.value)}
            />
        </div >
    );
}
/**
 * Primary Component
 */
const Duplicates = () => {

    //App hooks
    const history = useHistory();
    const { state } = useLocation<ViewState>();

    //Data hooks

    const [openMerge, setOpenMerge] = useState<boolean>(false);
    const [selectedMatch, setSelectedMatch] = useState<StudentMatch>();
    const [studentFrom, setStudentFrom] = useState<StudentMerge>();
    const [studentTo, setStudentTo] = useState<StudentMerge>();


    const [searchData, setSearchData] = useState<Therapists[]>([]);
    const [studentsData, setStudentsData] = useState<StudentMatch[]>([]);

    const [originalStudentsData, setOriginalStudentsData] = useState<StudentMatch[]>([]);

    const [districtName, setDistrictName] = useState<string>('');
    const [divisionName, setDivisionName] = useState<string>('');
    const [defaultDisciplineOption, setDefaultDisciplineOption] = useState<selectOption>();
    const [defaultDistrictOption, setDefaultDistrictOption] = useState<selectOption>();
    const [defaultDivisionOption, setDefaultDivisionOption] = useState<selectOption>();
    const [status, setStatus] = useState('');
    const [tricoreId, setTricoreId] = useState<number | undefined>();
    const [name, setName] = useState('');
    const [dobDate, setDobDate] = useState<Date>();
    const [message, setMessage] = useState<string>(state?.message ?? '');
     const [mergeErrors, setMergeErrors] = useState<string[]>([]);
    //Pagination
    const [totalRecordCount, setTotalRecordCount] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(0);
     const [studentFromId, setStudentFromId] = useState<number>(0);
    const [studentToId, setStudentToId] = useState<number>(0);
    const [isSuccess, setIsSuccess] = useState<boolean>(true)

    const [isPending, setIsPending] = useState<boolean>(false);
    const getDuplicatesDefer = async (args: any[]) => {
        return await getPotentialDuplicates();
    }

    const getDuplicatesAsync = useAsync({
        deferFn: getDuplicatesDefer,
        onResolve: (r) => {
            setTotalRecordCount(r.data.studentMatches.length);
            setStudentsData(r.data.studentMatches);
            setOriginalStudentsData(r.data.studentMatches);
            setPageSize(5);
        },
    });

     const getStudentMergeDetailsById = async (args: any[]) => {
        debugger
        if (studentFromId > 0 && studentToId > 0) {
            if (studentFromId === studentFrom?.studentId && studentToId === studentTo?.studentId) {

                setOpenMerge(true);
            }
            else {
                const request: StudentCustomMergRequest = {
                    studentFromId: studentFromId,
                    studentToId: studentToId
                }
                return await getManualDuplicates(request);
            }
        }
    }

    const getStudentMergeDetailsByIdAsync = useAsync({
        deferFn: getStudentMergeDetailsById,
        onResolve: (r) => {
            debugger;
            if (r !== undefined) {
                setStudentFrom(r.data.studentMerge[0]);
                setStudentTo(r.data.studentMerge[1]);
            }
        },
    });
    const mergeStudentsDefer = async (args: any[]) => {
        if (studentFrom !== undefined && studentTo !== undefined) {
            setIsPending(true);
            return await mergeStudents({
                studentFrom: studentFrom!.studentId!,
                studentTo: studentTo!.studentId!
            });
        }
    }

    const mergeStudentsAsync = useAsync({
        deferFn: mergeStudentsDefer,
        onResolve: (r) => {
            if (studentFrom !== undefined && studentTo !== undefined && r?.data?.result?.item1 == true) {
            var filtered = originalStudentsData.filter(x => x.student1.studentId !== studentFrom?.studentId && x.student2.studentId !== studentFrom?.studentId);
            setOriginalStudentsData(filtered);
             setIsSuccess(true);
                setMessage(r?.data?.result?.item2 as string);
                setMergeErrors(r?.data?.result?.item3 as string[]);
            setStudentFrom(undefined);
            setStudentTo(undefined);

            setOpenMerge(false);
             setIsPending(false);
            }
            else{
                 setOpenMerge(false);
                setIsSuccess(false);
                setMessage(r?.data?.result?.item2 as string);
                setMergeErrors(r?.data?.result?.item3 as string[]);
                setIsPending(false);
            }
        },
    });


const mergeButtonClick = (_stuFromId: number, _stuToId: number) => {
        setIsPending(true);
        if (_stuFromId > 0 && _stuToId > 0) {
            if (studentFromId === _stuFromId && studentToId === _stuToId) {
                setOpenMerge(true);
            }
            else {
                setStudentFromId(_stuFromId);
                setStudentToId(_stuToId);
            }
        }
    }

    useEffect(() => {
        getDuplicatesAsync.run();
    }, []);

    useEffect(() => {
         setIsPending(false);
        if (studentFrom !== undefined && studentTo !== undefined) {
            setOpenMerge(true);
        }
  }, [studentFrom, studentTo]);

    useEffect(() => {
        if (studentFromId > 0 && studentToId > 0)
            getStudentMergeDetailsByIdAsync.run();
    }, [studentFromId, studentToId]);



    useEffect(() => {
        var students = originalStudentsData;
        //Filtering        
        if (name !== "") {
            students = students.filter(
                x => x.student1.firstName.toLowerCase().includes(name.toLowerCase()) ||
                    x.student1.lastName.toLowerCase().includes(name.toLowerCase()) ||
                    x.student2.firstName.toLowerCase().includes(name.toLowerCase()) ||
                    x.student2.lastName.toLowerCase().includes(name.toLowerCase())
            );
        }

        if (districtName !== "") {
            students = students.filter(x => x.districtName.toLowerCase().includes(districtName.toLowerCase()));
        }

        if (dobDate !== undefined && dobDate != null) {
            students = students.filter(x =>
                moment(x.student1.dob.toString()).format('MM/DD/YYYY') == moment(dobDate.toString()).format('MM/DD/YYYY') ||
                moment(x.student2.dob.toString()).format('MM/DD/YYYY') == moment(dobDate.toString()).format('MM/DD/YYYY')
            );
        }

        setTotalRecordCount(students.length);

        //Pagination
        let low = (pageNumber - 1) * pageSize;
        let high = (pageNumber * pageSize) - 1;

        students = students.slice(low, high + 1);

        setStudentsData(students);


    }, [name, districtName, dobDate, pageNumber, pageSize, originalStudentsData])

    const handlePageSizeChange = (pageSizeSelection: string) => {
        const pageSize = Number.parseInt(pageSizeSelection);
        setPageNumber(1); // Reset page number on page size change
        setPageSize(pageSize);
    }

    const handlePageChange = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    return (
        <Layout isLoading={
               getDuplicatesAsync.isPending || isPending
        }>
            <Fragment>
                <Modal
                    saveText='Merge'
                    open={openMerge}
                    allowSave ={studentTo !== undefined && studentFrom !== undefined}
                    onCancel={() => {
                        setOpenMerge(false);
                    }}
                    onSave={() => {
                        mergeStudentsAsync.run();
                    }}
                >
                   <StudentMergeModel
                        studentFrom={studentFrom}
                        setStudentFrom={setStudentFrom}
                        studentTo={studentTo}
                        setStudentTo={setStudentTo}
                    ></StudentMergeModel>
                </Modal>
                 {message && <Notification onClose={() => {
                    setMessage('');
                    setMergeErrors([]);
                }} isSuccess={isSuccess} ><div>
                        <p>{message}</p>
                        {!isSuccess && mergeErrors.length > 0 && (
                            <ul className="list-disc pl-5 mt-2">
                                {mergeErrors.map((err, idx) => (
                                    <li key={idx} className="text-sm">{err}</li>
                                ))}
                            </ul>
                        )}
                    </div></Notification>}
                {/* Primary Container */}
                <div className='z-0 px-4 py-5 bg-white sm:p-6'>
                    {/* Search Fields */}
                    <div className='z-0 grid grid-cols-6 gap-6'>
                        <div className='col-span-6 sm:col-span-3 lg:col-span-2'>
                            <FetchInput
                                value={name}
                                rounded='sm'
                                placeholder=''
                                label={`Student Name`}
                                key={"student_ac"}
                                onClear={() => setName('')}
                                onChange={(value: string) => setName(value)}
                                icon={'search'}
                            />
                        </div>
                        <div style={{ position: 'relative', top: '-4px' }} className='col-span-6 sm:col-span-6 lg:col-span-1'>
                            <label style={{ position: 'relative', top: '4px' }} className='primary'>
                                Date Of Birth
                            </label>
                            <DatePicker
                                className='block mt-1 primary'
                                selected={dobDate}
                                onChange={(date: Date) => setDobDate(date!)}
                                maxDate={new Date()}
                            />
                        </div>
                        <div className='col-span-6 sm:col-span-3 lg:col-span-2'>
                            <FetchInput
                                value={districtName}
                                rounded='sm'
                                placeholder=''
                                label={`District`}
                                onClear={() => setDistrictName('')}
                                onChange={(value: string) => setDistrictName(value)}
                                icon={'search'}
                            />
                        </div>

                    </div>



                </div>

                {/* Results Table */}
                {studentsData !== null && studentsData !== undefined && (
                    <div className='results-table'>
                        {studentsData.length > 0 && (
                            <div className='overflow-hidden border-b border-gray-200 shadow'>
                                <table className='min-w-full divide-y divide-gray-200'>
                                    <thead className='text-left text-black bg-ptstableheader'>
                                        <tr>
                                            <th></th>
                                            <th>District</th>
                                            <th>Name</th>
                                            <th>Date of Birth</th>
                                            <th>PTS ID</th>
                                            <th>Added</th>
                                        </tr>
                                    </thead>


                                    {studentsData.map((row, i) => {
                                        return (
                                            <tbody className='bg-white divide-y divide-gray-200'>
                                                <tr>
                                                     <td className="p-5" rowSpan={2}>
                                                        <button type="button" onClick={() => {
                                                            mergeButtonClick(row.student1.studentId, row.student2.studentId);
                                                        }}>Merge</button>
                                                    </td>
                                                    <td rowSpan={2}>{row.districtName}</td>
                                                    <td className="pt-5">{row.student1.lastName}, {row.student1.firstName}</td>
                                                    <td className="pt-5">{moment(row.student1.dob.toString()).format('MM/DD/YYYY')}</td>
                                                    <td className="pt-5">{row.student1.studentId}</td>
                                                    <td className="pt-5">{row.student1.createdOn ? moment(row.student1.createdOn!.toString()).format('MM/DD/YYYY') : "-"} by {row.student1.createdByUserFirstName} {row.student1.createdByUserLastName}</td>
                                                </tr>
                                                <tr>
                                                    <td className="pb-5">{row.student2.lastName}, {row.student2.firstName}</td>
                                                    <td className="pb-5">{moment(row.student2.dob.toString()).format('MM/DD/YYYY')}</td>
                                                    <td className="pb-5">{row.student2.studentId}</td>
                                                    <td className="pb-5">{row.student2.createdOn ? moment(row.student2.createdOn!.toString()).format('MM/DD/YYYY') : "-"} by {row.student2.createdByUserFirstName} {row.student2.createdByUserLastName}</td>
                                                </tr>
                                            </tbody>
                                        )
                                    })}
                                </table>
                                <div className='flex items-center justify-between pb-3 pl-5'>
                                    <PageSizeSelector
                                        currentPageSize={pageSize}
                                        options={therapistPageSizeOptions}
                                        changeHandler={handlePageSizeChange}
                                        outerDivClasses=''
                                    />
                                </div>
                                {totalRecordCount > 0 &&
                                    <Pagination
                                        key={`page_${pageNumber}`} // This is critical to parent/child communication
                                        totalRecordCount={totalRecordCount}
                                        recordLimit={pageSize}
                                        parentCurrentPage={pageNumber}
                                        changeHandler={handlePageChange}
                                    />
                                }
                            </div>
                        )}
                    </div>
                )}


                {/* No therapists found message */}
                {studentsData.length === 0 && (
                    <div>
                        <label>No potential duplicates found.</label>
                        <div className='px-4 py-3 bg-gray-100 sm:px-6 sm:flex sm:flex-row-reverse'>

                        </div>
                    </div>
                )}
            </Fragment>
        </Layout>

    );
};

export default Duplicates;
